export const DEFAULT_PAGE_SIZE = 25;

export const USER_VALIDATION_ERROR = {
  title: 'Cannot Add User',
  message:
    'New users must be associated to either a buyer, a supplier, or be test users',
  type: 'danger' as const,
};

export const LINK_USER_TO_BUYERS_NOTIFICATION = {
  title: 'Success',
  message: 'User successfully linked to the selected buyers',
  type: 'success' as const,
};

export const USER_CONFIRM_SUCCESS = {
  title: 'Confirm User',
  message:
    "User is confirmed. Please refresh the page if the user doesn't appear.",
  type: 'success' as const,
};

export const USER_CONFIRM_FAILURE = {
  title: 'Confirm User',
  message: 'User confirmation failed. Please try again.',
  type: 'danger' as const,
};

export const DEBOUNCE_TIME = 300;
